export default {
  common: {
    login: "Iniciar sesión",
    userName: "Nombre de usuario",
    password: "Contraseña",
    rememberPassword: "Recordar",
    modifyPassword: "Modificar contraseña",
    accountRegister: "Registrar cuenta",
    pleaseInput: "Por favor ingrese",
    loginErrorCheckNamePassword: "Inicio de sesión fallido, por favor verifique el nombre de usuario y la contraseña",
    guest: "Invitado",
    superAdmin: "Super Administrador",
    logOut: "Cerrar sesión",
    inputUserName: "Ingrese el nombre de usuario",
    inputPassword: "Ingrese la contraseña",
    modifySuccessfully: "Se modificó con éxito la contraseña!",

    using: "Usando",
    toLogin: "para iniciar sesión",
    noOktaLoginUrl: "No hay URL de inicio de sesión de OKTA"
  },
  register: {
    email: "Correo electrónico",
    confirmPassword: "Confirmar contraseña",
    register: "Registrar",
    emailRequire: "Se requiere correo electrónico",
    passwordRequire: "Se requiere contraseña",
    confirmPasswordRequire: "Se requiere confirmar la contraseña",
    passwordInconsistency: "Inconsistencia de contraseña",
    registeredSuccessfully: "¡Registrado con éxito!",
    jumpToLoginPage: "El sistema te redirigirá automáticamente a la página de inicio de sesión.",
    contactAdminActivate: "Póngase en contacto con el Administrador antes de iniciar sesión para activar la cuenta."
  },
  my: {
    about: "Acerca de",
    language: "Idioma"
  }
}



// WEBPACK FOOTER //
// ./src/locale/login/es.js